<template>
  <!-- 企业风采 -->
  <div class="elegant">
    <div class="swiper elegant-swiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item,index) in elegantList"
          :key="index"
          @click="goToDetail(item.uuid)"
        >
          <div class="elegant-img" :style="{ backgroundImage: `url(${item.pic})` }">
            <div class="elegant-title">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="swiper-button-next swiper-button-white"></div>
      <div class="swiper-button-prev swiper-button-white"></div>
    </div>
  </div>
</template>
<script>
import { getElegantList } from "../../utils/interface";
export default {
  data() {
    return {
      elegantList: []
    };
  },
  mounted() {
    this.getElegantList();
  },
  methods: {
    init() {
      var elegantSwiper = new Swiper(".elegant-swiper", {
        effect: "coverflow",
        loop: true, // 循环
        mousewheel: true, // 鼠标可控制swiper切换
        autoplay: {
          delay: 5000, //5秒切换一次
          disableOnInteraction: false, // 触碰之后不会停止自动切换
          pauseOnMouseEnter: true // 鼠标移入暂停动画,移除继续动画
        },
        slidesPerView: 2.5,
        centeredSlides: true,
        coverflowEffect: {
          rotate: -20,
          stretch: 10,
          depth: 90,
          modifier: 2,
          slideShadows: false
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    },
    getElegantList() {
      getElegantList({
        current: 1,
        pageSize: 20,
        rec: 1
      }).then(res => {
        if (res.list.length) {
          this.elegantList = res.list;
          this.$nextTick(() => {
            this.init();
          });
        } else {
          this.elegantList = [];
        }
      });
    },
    goToDetail(uuid) {
      let router = this.$router.resolve({
        path: "./elegantDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(router.href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.swiper-button-next.swiper-button-white,
.swiper-button-prev.swiper-button-white {
  --swiper-navigation-color: #2d50a1;
  border: 2px solid #2d50a1;
  border-radius: 50%;
  width: 44px;
  height: 44px;
}
.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after,
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  font-weight: 600;
  font-size: 22px;
}
.elegant {
  margin-top: 34px;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  border: 1px solid #2d50a1;
  border-radius: 12px;
  cursor: pointer;
  .elegant-img {
    width: 100%;
    height: 312px;
    background-size: 100% 100%;
    border-radius: 12px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: end;
    .elegant-title {
      color: #fff;
      font-size: 22px;
      margin: 0 0 20px 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/innovateService/elegant.vue